import { createAction, props } from "@ngrx/store";
import { IIndustryItem } from "@skills-app/models/industry";

const prefix = "[Consultant-Search-Industry API]";

export const requestIndustryItems = createAction(
  `${prefix} Request Industry Items`,
);

export const requestIndustryItemsError = createAction(
  `${prefix} Request Industry Items Error`,
);

export const populateIndustryItems = createAction(
  `${prefix} Populate Industry Items`,
  props<{ items: IIndustryItem[] }>(),
);

export const unloadComponent = createAction(`${prefix} Unload Component`);
